import { useState } from "react";

const ItineraryTimeline = ({ itineraries }) => {
  // Only one day expanded at a time
  const [expandedDay, setExpandedDay] = useState(1);

  const toggleDay = (day) => {
    setExpandedDay(expandedDay === day ? expandedDay : day);
  };

  return (
    <div className="itinerary-content">
      <p className="text-gray-700 mb-6 text-base">
        We've curated the best itinerary to give you the exciting travel
        experience you deserve.
      </p>

      <div className="bg-white-200 pb-4 rounded-2xl border border-black-100/10">
        {itineraries?.length > 0 &&
          itineraries.map((day, index) => {
            const dayNumber = index + 1;
            const isExpanded = expandedDay === dayNumber;
            const isLast = index === itineraries.length - 1;

            return (
              <div className={` relative `} key={dayNumber}>
                {/* Timeline connector line */}
                {!isLast && (
                  <div className="absolute left-6 top-12 bottom-0 w-0.5 bg-gray-200 z-0"></div>
                )}

                <div className="relative z-10 ">
                  {/* Day header */}
                  <div
                    className="flex justify-between gap-x-4 items-center p-4 cursor-pointer"
                    onClick={() => toggleDay(dayNumber)}
                  >
                    <div className="">
                      {/* Circle marker - different style for expanded/active days */}
                      <div
                        className={`
                      flex-shrink-0 h-2 w-2 rounded-full  shadow-lg 
                      ${
                        isExpanded
                          ? "bg-blue-100 ring-4 ring-white-100  "
                          : "bg-blue-100"
                      }
                    `}
                      ></div>
                    </div>

                    <div
                      className={`${
                        expandedDay !== dayNumber &&
                        "border-b border-black-100/10"
                      } flex-1 flex items-center  justify-between `}
                    >
                      <div className="">
                        <span className="font-bold text-blue-500">
                          Day {dayNumber}
                        </span>
                        <span className="text-gray-700 ml-2">{day.title}</span>
                      </div>

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className={`transition-transform text-gray-500 ${
                          isExpanded ? "transform rotate-180" : ""
                        }`}
                      >
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </div>
                  </div>

                  {/* Expanded content with vertical line */}
                  {isExpanded && (
                    <div className="relative pl-12 pr-4 pb-1">
                      {/* Vertical line on the side of expanded content */}
                      <div className="absolute left-5 top-0 bottom-0 w-0.5 bg-black-100/10"></div>

                      <div className="border-b border-black-100/10 pb-4">
                        <p className="text-gray-700">{day.description}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ItineraryTimeline;
